<template>
  <div class="base-wrapper" :key="$route.params.slug">

    <div class='content-wrapper'>


      <div class="header-content uk-visible@s" id="dashboard-header">

        <span :class="{
        'header-icon': true,
        'flaticon-cubes': geographyType === 'District',
        'flaticon-nested-cube': geographyType === 'Branch',
        'flaticon-garage': geographyType === 'Facility-ID',
        'flaticon-headquarter': geographyType === 'Club',
        'flaticon-employee': geographyType === 'Driver' || geographyType === 'Org-Field-Rep'}"></span>
        <h1 class="headerDisplayName">{{displayName}}</h1>
        <div class='subheader spread'>
          <h5>{{geographyType}}</h5>
          <!--<h6 v-if="permissions.includes('see-siblings') && myParent"-->
          <!--:key="myParent.id"-->
          <!--class="seconday">-->
          <!--<a href="#" @click="$router.push(myParent.url)">-->
          <!--{{myParent.real_name}}-->
          <!--</a>-->
          <!--</h6>-->
          <h6 v-for="(parent, idx) in parentalArray"
              v-if="permissions.includes('see-all') && parentalArray.length"
              :key="parent.slug"
              class="seconday">
            <a href="#" @click="reloadTo(parent.url)">
              <span v-for="i in [...Array(idx + 1)]" :key="i">→ </span>
              {{parent.name}}
            </a>
          </h6>
        </div>
      </div>

      <div class="header-content uk-hidden@s" id="dashboard-header-mobile">
        <div>
        <span :class="{
        'header-icon': true,
        'flaticon-cubes': geographyType === 'District',
        'flaticon-nested-cube': geographyType === 'Branch',
        'flaticon-garage': geographyType === 'Facility-ID',
        'flaticon-headquarter': geographyType === 'Club',
        'flaticon-employee': geographyType === 'Driver' || geographyType === 'Org-Field-Rep'}"></span>
          <h1 class="headerDisplayName">{{displayName}}</h1>
        </div>
        <div class='subheader spread'>
          <h5>{{geographyType}}</h5>
          <!--<h6 v-if="permissions.includes('see-siblings')"-->
          <!--:key="myParent.id"-->
          <!--class="seconday">-->
          <!--<a href="#" @click="$router.push(myParent.url)">-->
          <!--{{myParent.real_name}}-->
          <!--</a>-->
          <!--</h6>-->
          <h6 v-for="(parent, idx) in parentalArray"
              v-if="permissions.includes('see-all') && parentalArray.length"
              :key="parent.slug"
              class="seconday">
            <a href="#" @click="$router.push(parent.url)">
              <span v-for="i in [...Array(idx + 1)]" :key="i">→ </span>
              {{parent.name}}
            </a>
          </h6>
        </div>
      </div>

      <alert class="uk-alert-warning dashboard-alert"
             v-if="permissions.includes('cant-see-dashboard')"
             :data="{
                    title:'Our records show you have not completed training!',
                    body:'Please complete training first, or allow us a few days to process completion to see the dashboard.',
                    icon: 'warning',
              }" v-intro-scroll-to="'element'"></alert>


      <div class="uk-section dashboard-section" v-if="!permissions.includes('cant-see-dashboard')">


        <div class='tab-section' id="dashboard-compliance-section">

          <alert class="uk-alert-success dashboard-alert"
                 v-if="checkIDEligible"
                 :data="{
                    title:'You are eligible for Check ID Incentives!',
                    body:'The graphs below describe how close you are to reaching them. ',
                    icon: 'check',
              }" v-intro-scroll-to="'element'"></alert>

          <div class="dashboard-card-container">

            <div class="uk-card uk-card-default">
              <div class="uk-card-header">
                <button class="uk-button uk-button-default date-select-button"
                        @click="showDatePickers = !showDatePickers" type="button">
                  Select Date Range for Metrics
                </button>
              </div>

              <div class="" v-show="showDatePickers">
                <div class="datepicker-container">
                  <div>
                    <h5>From</h5>
                    <datepicker
                            :inline="true"
                            :typeable="true"
                            format="YYYY-MM-DD"
                            v-model="timeConstraints.from"
                            :disabledDates="{to: new Date(2019, 0, 1), from: new Date()}"
                    />
                  </div>
                  <div>
                    <h5>To</h5>
                    <datepicker
                            :inline="true"
                            :typeable="true"
                            format="YYYY-MM-DD"
                            v-model="timeConstraints.to"
                            :disabledDates="{to: new Date(2019, 0, 1), from: new Date()}"
                    />
                  </div>
                </div>
                <button class="uk-button uk-button-default uk-button-secondary" @click="makeCustomDateDataRequest"
                        type="button">Submit
                </button>
              </div>
            </div>
          </div>
          <div class='dashboard-card-container'>
            <generic-percentage-card v-for="(c, i) in cards" :data="c" :odd="i%2==0" :thru_date="thru_date"
                                     :from_date="from_date"/>
          </div>
          <div class="dashboard-card-container">
            <data-table v-if="childData && geographyType!='Driver' && showChildDataTable"
                        :data="processTableData(childData)"
                        :name="displayName + ' Check ID Overview'" :col_conversion="{'link': ''}"></data-table>
            <data-table v-if="trainingData && geographyType!='Driver'" :data="processTableData(trainingData)"
                        :name="displayName + trainingTitle" message="This data is updated weekly on Monday"
                        :col_conversion="{'link': ''}"></data-table>
            <!--<eligibility-card-->
            <!--:peer-rank="peerRank"-->
            <!--:eligible-volume="eligibleVolume"-->
            <!--:volume="volume"-->
            <!--:org-type="user.organization.type"-->
            <!--/>-->
          </div>
        </div>
      </div>


    </div>
    <!--          <modal id="demo-modal" :data="{title:'WELCOME!', body: 'We have some new features we would like to introduce to you.',-->
    <!--      cancel: 'No thanks.', accept: 'Show me!'}" @accept="startTour"></modal>-->
    <!--              <modal id="demo-done" :data="{title:'Need Extra Help?', body: 'Ifpulsing dot, click it to get some extra help.', html: '<div class=introjs-hint><div class=introjs-hint-dot></div><div class=introjs-hint-pulse></div></div></div>', accept: 'Got it!'}"></modal>-->
    <Demo :showName="demo"></Demo>
  </div>
</template>

<script>

	var introJS = require('intro.js') // necessary for intro stuff
	import "intro.js/minified/introjs.min.css"; //necessary for intro stuff
	import UIkit from 'uikit'; // necessary for intro stuff
	import _ from 'lodash';

	import Modal from "./theme/Modal.vue";
	import Demo from "./theme/Demo.vue";
	import apicall from '@/store/apicall'
	import deslug from '../utils/deslug'
	import Moment from 'moment';
	import Datepicker from 'vuejs-datepicker';

	import DynamicCharts from './DynamicCharts'

	import Alert from "./theme/Alert.vue"

	import ComplianceCard from "./dashboard/ComplianceCard"
	import EligibilityCard from "./dashboard/EligibilityCard"
	import DriverRankCard from "./dashboard/DriverRankCard"
	import Mapbox from "./mapbox"
	import Surveys from "./surveys"
	import DataTable from "./theme/DataTable.vue"
	import genericPercentageCard from "./dashboard/genericPercentageCard"

	import validators from "@/utils/validate.js"


	const makeDataRequest = function (context) {

		//this function will never get called without a slug.
		// The only function that should call this is generatePage, which is enforces the slug in our routes.
		// If there is no slug in generate page, it reroutes you to a page with a slug.
		const _t = context;
		const slug = _t.slug;
		const type = _t.type;

		//data updates imperfect. Set max updates to 1 so we don't overblow the problem.
		apicall.post('/dashboard/', {'thru_date': 1})
				.then((res) => {
					_t.thru_date = Moment.utc(res.data).format('MMMM, DD YYYY');
				})
				.catch((err) => console.log(err));


		//most cases will use this request;

    //there's a bug in the API that still needs to be fixed. calls to a "_rate" metric will always be zero unless
    // you also call the correspondoing "_sum" metric.
		let request = {
			"slug": slug,
			"type": type,
			"purpose": "calendar_custom",
			"parameters": {
				"metrics": [
					"total_volume_sum",
					"match_sum",
					"match_rate",
					"scan_sum",
					"scan_rate",
					"decline_run_call_sum",
					"decline_run_call_rate",
					"no_id_match_sum",
					"no_id_match_rate"
				],
				"from": new Moment(_t.timeConstraints.from).format('YYYY-MM-DD'),
				"to": new Moment(_t.timeConstraints.to).format('YYYY-MM-DD'),
				"relation": "self"
			}
		}


		let requestForChildData = {
			"slug": slug,
			"type": type,
			"purpose": "calendar_custom",
			"parameters": {
				"metrics": [
					"total_volume_sum",
					"match_sum",
					"match_rate",
					"scan_sum",
					"scan_rate",
					"decline_run_call_sum",
					"decline_run_call_rate",
					"no_id_match_sum",
					"no_id_match_rate"
				],
				"from": new Moment(_t.timeConstraints.from).format('YYYY-MM-DD'),
				"to": new Moment(_t.timeConstraints.to).format('YYYY-MM-DD'),
				"relation": "children"
			}
		}

		console.log("TYPE", type)
		let requestForTrainingData = {
			"slug": slug,
			"type": type,
			"training": 1,
		}

		_t.showChildDataTable = false;
		apicall.post('/dashboard/', requestForChildData)
				.then((res) => {
					console.log("child data", res.data)
					_t.childData = res.data
					_t.showChildDataTable = true;
				})
				.catch((err) => console.log(err))


		apicall.post('/dashboard/', request)
				.then((res) => {
					console.log("RES DATA", res.data)
					_t.selfData = res.data[0] //returns an array wrapped in another one. annoying. May get around to fixing this later.
				}).catch((err) => {
			console.log(err);
		})


		if (!(['Driver', 'Field-Rep', 'Facility-ID'].indexOf(type) >= 0)) {
			apicall.post('/dashboard/', requestForTrainingData)
					.then((res) => {
						_t.trainingData = res.data
					})
					.catch((err) => {
						console.log(err);
					})
		} else {
			_t.trainingData = false
		}

	};


	const makeCustomDateDataRequest = function (context) {

		const _t = context;

		const slug = _t.slug;
		const type = _t.type;

		//most cases will use this request;
		let request = {
			"slug": slug,
			"type": type,
			"purpose": "calendar_custom",
			"parameters": {
				"metrics": ["match_sum", "total_volume_sum", "match_rate",
					"decline_run_call_sum", "decline_run_call_rate",
					"no_id_match_sum", "no_id_match_rate",
					"scan_sum", "scan_rate"],
				"time_type": ["Day"],
				"relation": ["self", "children"],
				"from": new Moment(_t.timeConstraints.from).format('YYYY-MM-DD'),
				"to": new Moment(_t.timeConstraints.to).format('YYYY-MM-DD')
			}
		}

		_t.showChildDataTable = false;
		return apicall.post('/dashboard/', request)
				.then((res) => {
					_t.selfData = res.data["self"][0];
					console.log(res.data, JSON.stringify(res.data));
					_t.childData = res.data["children"];
					_t.showChildDataTable = true;
				}).catch((err) => {
					console.log(err);
				})

	};


	function generatePage(context) {
		const _t = context;

		let selectedSlug, selectedType;
		console.log("PARAMS CHECK", _t.$route.params);
		if (_t.$route.params.slug) {
			apicall.post('/accounts/organizations/', {"slug": _t.$route.params.slug})
					.then(function (response) {
						_t.$store.dispatch('updateGeography', response.data);
						selectedSlug = response.data.slug;
						_t.slugUpdated = true
						if ('first_name' in response.data) {
							selectedType = response.data.position_type;
						} else {
							selectedType = response.data.type;
						}

					})
					.catch((err) => {
						if (_t.$store.state.user.data.organization) {
							const {organization} = _t.$store.user.data;
							selectedSlug = organization.slug;
							selectedType = organization.type;
						}
					})
					.then(() => {
						_t.type = selectedType;
						_t.slug = selectedSlug;
						_t.dataRequest();


					})

		} else if (_t.$store.state.user.data.organization) {
			//generic url. Push them to the slugged URL.
			let {organization} = _t.$store.state.user.data;
			organization = organization[0];

			//if it's an executive, push them to a new slug.
			if (_t.user.position_type === 'Executive') {
				selectedSlug = 'ace';
				selectedType = 'Club'
			}
			//push to slug (Starts the whole process over again)
			else if (_t.user.position_type === 'Facility-Associate') {
				selectedSlug = organization.slug;
				selectedType = organization.type;
			}
			else {
				selectedSlug = _t.user.slug;
				selectedType = 'Employee';
			}

			window.location = '/dashboard/' + selectedSlug
			_t.slug = selectedSlug;
			_t.type = selectedType;

		} else {
			//no slug and no organization. What are you doing here?
			_t.$router.push('login');
		}
	}


	export default {
		name: 'Dashboard',
		components: {
			Alert,
			ComplianceCard,
			EligibilityCard,
			DriverRankCard,
			DynamicCharts,
			Mapbox,
			Modal,
			Demo,
			Surveys,
			DataTable,
			genericPercentageCard,
			Datepicker
		},
		data: function () {
			return {
				dashboardSection: 1,
				checkIDEligible: false,
				volume: 0,
				compliedCount: 0,
				peerRank: 0,
				// dataMeasureStartDate: new Moment().format("MMMM 1"), //first of the month
				dataMeasureStartDate: "June 24, 2019",
				demo: "Dashboard",
				showIntro: false,
				apiCallResult: null,
				slugUpdated: false,
				completedTraining: true,
				slugType: 'emp',
				childData: null,
				showChildDataTable: false,
				selfData: null,
				// cards: [],
				from_date: "June 24, 2019",
				thru_date: new Moment().format("MMMM DD, YYYY"),
				trainingData: null,
				slug: null,
				type: null,
				timeConstraints: {
					to: new Date(),
					from: new Date(new Moment().subtract(30, 'days').toISOString()),
				},
				showDatePickers: false,
			}
		},
		methods: {

			makeCustomDateDataRequest: function () {
				const _t = this;
				makeCustomDateDataRequest(_t)
						.then(() => {
							_t.from_date = new Moment(_t.timeConstraints.from).format("MMMM DD, YYYY");
							_t.thru_date = new Moment(_t.timeConstraints.to).format("MMMM DD, YYYY");
						})

			},
			processTableData: function (data) {
				let output = []
				data.forEach(function (unit) {

					let newRow = {}
					let name = unit.name;
					let slug = unit.id[2]
					let unit_id = unit.id[1]
					let unit_type = unit.id[0]
					let period = unit.groupName;
					let row = unit.data;

					//PASSING THE 'rowlink' key turns the whole thing into a link


					row.forEach(function (col) {
						newRow["Name"] = _.startCase(_.lowerCase(name));
						newRow['link'] = (unit_type === 'employee_id') ? '/dashboard/' + unit_id : '/dashboard/' + slug;
						newRow["Period"] = period;
						newRow[col.label] = Math.round(col.value);

					})
					//only add to output if there is volume
					if (newRow.total_volume_sum !== 0) {
						output.push(newRow);
					}


				})
				return output
			},

			dataRequest: function () {
				return makeDataRequest(this);
			},

			reloadTo: function (url) {
				window.location = url;
			}

		},
		computed: {
			// eligibleVolume: function () { //FIX THIS SHIT
			// 	return Math.floor(this.volume * .9);
			// },

			trainingTitle: function () {
				if (this.geographyType == 'Org-Field-Rep') {
					return " Drivers Missing Training"
				} else {
					return " Training Overview"
				}
			},

			permissions: function () {
				if (this.$store.state.user.data.permission) {
					let permissions = this.$store.state.user.data.permission;
					let permission_names = []
					permissions.forEach(function (p) {
						permission_names.push(p.name)
					});

					if (!this.user.completed_training && this.user.position_type === 'Driver') {
						permission_names.push('cant-see-dashboard')
					}


					return permission_names
				} else {
					return []
				}

			},

			cards: function () {
				if (this.selfData) {
					// return this.selfData
					let flattened = this.selfData.data.map(function (elem) {
						return {
							label: elem.label,
							value: elem.value
						}
					})
					let source = {}
					flattened.forEach(function (el) {
						source[el.label] = el.value
					})

					let cards = [
						{
							numerator: source['match_sum'],
							denominator: source['total_volume_sum'],
							rate: source['match_rate'],
							names: {
								numerator: "Check ID App Usage Count",
								denominator: "Total Calls",
								rate: "Check ID App Usage Rate",
								title: "Check ID App Usage"
							},
							startDate: "June 24, 2019"
						},
						{
							numerator: source['scan_sum'],
							denominator: source['match_sum'],
							rate: source['scan_rate'],
							names: {
								numerator: "Drivers License Scanned Count",
								denominator: "Check ID App Usage Count",
								rate: "Drivers License Scanned Rate",
								title: "Scanned Drivers License"
							},
							startDate: "June 24, 2019"
						},

						{
							numerator: source['no_id_match_sum'],
							denominator: source['match_sum'],
							rate: source['no_id_match_rate'],
							names: {
								numerator: "ID Unverified Count",
								denominator: "Check ID App Usage Count",
								rate: "ID Unverified Rate",
								title: "ID Was Not Verified "
							},
							startDate: "June 24, 2019"
						},
						{
							numerator: source['decline_run_call_sum'],
							denominator: source['match_sum'],
							rate: source['decline_run_call_rate'],
							names: {
								numerator: "Decline to Run Call",
								denominator: "Check ID App Usage Count",
								rate: "Decline to Run Call Rate",
								title: "Decline to Run Calls"
							},
							startDate: "June 24, 2019"
						},


					]
					if (this.user.position_type === 'Driver') {
						cards.splice(3, 1)
					}

					return cards

				} else {
					return null
				}
			},

			user: function () {
				return this.$store.state.user.data;
			},
			myParent: function () {
				if (this.$store.state.user.data.organization[0]) {
					let org = this.$store.state.user.data.organization[0]
					org['url'] = '/dashboard/' + org['slug']
					return org
				} else {
					return null
				}
			},

			parentalArray: function () {
				const _t = this;
				let parentArray = [];
				let permissions_obj = this.$store.state.user.data.permission;
				let permission_names = permissions_obj.map(permissions_obj => permissions_obj.name);
				// console.log(permission_names)
				let data = this.$store.state.geography.data;
				if (data.first_name) {
					data['parent'] = data.organization[0]
				}

				if (data.length > 0) {
					data = data[0]
				}
				let myOrg = this.$store.state.user.data.organization;
				console.log(myOrg, "MY ORG")
				let precedenceArray = ['Club', 'District', 'Branch', 'Org-Field-Rep', 'Facility-ID', 'Driver'];

				function lower_in_hierarchy(org, ref) {
					return (precedenceArray.indexOf(ref.type) > precedenceArray.indexOf(org.type))
				}

				// console.log('ORGANIZATION DATA', data);
				let i = 0;
				while (data['parent'] != null) {
					i += 1
					data['parent']['url'] = '/dashboard/' + data['parent']['slug'];
					if (permission_names.includes('see-all')) {
						parentArray.push(data['parent'])
					} else if (permission_names.includes('see-siblings') && myOrg[0].parent.id == data['parent']['id']) {
						parentArray.push(data['parent'])
					} else if (data['parent']['id'] == myOrg[0].id) {
						parentArray.push(data['parent'])
					} else if (lower_in_hierarchy(myOrg, data['parent'])) {
						parentArray.push(data['parent'])
					}
					data = data['parent']

				}
				return parentArray;
			},

			displayName: function () {
				if (this.$store.state.geography.data.real_name) {
					return this.$store.state.geography.data.real_name
				}
				else if (this.$store.state.geography.data.name) {
					return this.$store.state.geography.data.display_name
				} else if (this.$store.state.geography.data.first_name) {
					return this.$store.state.geography.data.first_name + ' ' + this.$store.state.geography.data.last_name
				}
				else if (this.user.first_name) {
					return this.user.first_name + ' ' + this.user.last_name
				} else {
					return "--";
				}

			},

			geographyType: function () {
				let geography = this.$store.state.geography.data;
				if (geography.length > 0) {
					geography = geography[0]
				}
				if (geography.first_name) {
					return geography.position_type
				} else {
					return geography.type;
				}

			},
		},

		watch: {
			$route(_to, _from) {
				if (_to.params.slug !== _from.params.slug) {
					generatePage(this);
				}
			}
		},

		mounted() {
			generatePage(this);

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

  @import "../assets/less/theme.less";
  @import "../assets/icons/geo_icons/flaticon.css";

  #documentation-trigger {
    position: fixed;
    right: 3vw;
    bottom: 4vh;
  }

  .dashboard-card-container {
    margin-bottom: 1.5em;
  }

  .secondary {
    color: @secondary-3
  }

  .dashboard-section {
    margin-top: 10px;
    padding-top: 0;
  }

  .content-wrapper {
    margin-top: 10px;
    padding-top: 0;
  }

  .header-content {
    border-bottom: 2px solid @secondary-2;
    margin-bottom: 25px;

    display: flex;
    justify-content: space-between;

    .name-header {
      display: flex;
      justify-content: flex-start;
      max-width: unset !important;
      align-items: flex-end;

      h1 {
        white-space: nowrap;
      }
    }

    .logo {
      max-width: 150px;
      margin-right: 10px;
    }

  }

  .uk-card {
    margin: 1em 0;
  }

  /*
    .header-content {
       background-color: @primary;
      color: snow;
    }
    */

  .datepicker-container {
    display: flex;
    justify-content: center;

    & > * {
      margin: 2em;
    }
  }

  .date-select-button {
    font-weight: bolder;
  }


</style>
